import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { AssessmentProvider } from "../src/components/assessmentContext";
import LandingPage from "./components/landing";
import SignIn from "./components/signIn";
import Questionnaires from "./components/questionnaires";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Question from "./components/question";
import ScrollToTop from "./components/scrollToTop";
import Result from "./components/result";
import ExcelProcessor from "./report/ExcelProcessor";
import OpportunityBubbleChart from "./chart/OpportunityBubbleChart";
import AssessmentReport from "./components/assessmentreport";

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleSignInSuccess = (remember, userInitial) => {
    setIsSignedIn(true);
    setUserName(userInitial || "");
    navigate("/");
  };

  useEffect(() => {
    // Helper function to get from localStorage or sessionStorage
    const getValue = (key) => {
      return localStorage.getItem(key) || "";
    };

    const userName = getValue("userName");
    const initial = getValue("initial");

    if (userName) {
      setIsSignedIn(true);
      setUserName(initial);
    }
    setLoading(false);
  }, []);

  const handleSignOut = () => {
    setIsSignedIn(false);
    setUserName("");

    // Clear all localStorage and sessionStorage
    localStorage.clear();
    // sessionStorage.clear();
  };

  const [isPortrait, setIsPortrait] = useState(null);
  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerWidth <= window.innerHeight);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isPortrait) {
    return (
      <img src="/assets/signInPage/rotate-device.webp" alt="Rotate Device" />
    );
  }

  if (loading) return <div className="loading"></div>;

  if (!isSignedIn) {
    return <SignIn onSignIn={handleSignInSuccess} />;
  }

  return (
    <AssessmentProvider>
      <Navbar userInitial={userName} onSignOut={handleSignOut} />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/questionnaires" element={<Questionnaires />} />
          <Route path="/question" element={<Question />} />
          <Route path="/results" element={<Result />} />
          <Route path="/projects" element={<LandingPage />} />
          <Route path="/ExcelProcessor" element={<ExcelProcessor />} />
          <Route path="/OpportunityBubbleChart" element={<OpportunityBubbleChart />} />
          <Route path="/AssessmentReport" element={<AssessmentReport />} />
        </Routes>
      </ScrollToTop>
      <Footer />
    </AssessmentProvider>
  );
}

export default App;
